module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('cell', {
    attrs: {
      "is-link": ""
    }
  }, [_c('i', {
    staticClass: "fa  fa-home",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "ml20",
    slot: "after-title"
  }, [_vm._v("Vue-Alex")]), _vm._v(" "), _c('span', [_vm._v("技术栈")])]), _vm._v(" "), _c('swiper', {
    style: (_vm.bg),
    attrs: {
      "auto": "",
      "loop": "",
      "dots-position": "center"
    },
    model: {
      value: (_vm.index),
      callback: function($$v) {
        _vm.index = $$v
      },
      expression: "index"
    }
  }, [_c('swiper-item', {
    staticClass: " text-center  lh-180 font-48"
  }, [_c('i', {
    staticClass: "fa fa-code",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("ES6")])]), _vm._v(" "), _c('swiper-item', {
    staticClass: " text-center  lh-180"
  }, [_c('img', {
    staticClass: "img-50",
    attrs: {
      "src": "http://vuejs.org/images/logo.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('swiper-item', {
    staticClass: " text-center   lh-180 font-48"
  }, [_c('i', {
    staticClass: "fa fa-css3",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('swiper-item', {
    staticClass: " text-center  lh-180 font-48"
  }, [_c('i', {
    staticClass: "fa fa-html5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('swiper-item', {
    staticClass: " text-center  lh-180 font-48"
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("GitHub")])]), _vm._v(" "), _c('swiper-item', {
    staticClass: " text-center  lh-180"
  }, [_c('img', {
    staticClass: "img-center",
    attrs: {
      "src": "https://webpack.github.io/assets/logo.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('swiper-item', {
    staticClass: " text-center  lh-180"
  }, [_c('img', {
    staticClass: "img-center",
    attrs: {
      "src": "https://raw.githubusercontent.com/babel/logo/master/babel.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('swiper-item', {
    staticClass: " text-center  lh-180"
  }, [_c('img', {
    staticClass: "img-center",
    attrs: {
      "src": "https://github.com/yarnpkg/assets/blob/master/yarn-kitten-full.png?raw=true",
      "alt": ""
    }
  })]), _vm._v(" "), _c('swiper-item', {
    staticClass: " text-center  lh-180"
  }, [_c('img', {
    staticClass: "img-center",
    attrs: {
      "src": "https://raw.githubusercontent.com/airyland/vux/master/logo.png"
    }
  })])], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "is-link": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-file-code-o",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("More")]), _vm._v(" "), _c('span', {
    staticClass: "ml20 colorC",
    slot: "after-title"
  }, [_vm._v("See my Article")])])], 1), _vm._v(" "), _c('book', {
    attrs: {
      "title": "JavaScript",
      "text": _vm.txt,
      "img": _vm.photo,
      "link": "article"
    }
  }), _vm._v(" "), _c('book', {
    attrs: {
      "title": "CSS3",
      "classification": "CSS3",
      "text": _vm.text1,
      "link": "article"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-86a9ec0e"}!./~/.1.0.61@vux-loader/src/template-loader.js!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 115
// module chunks = 1